import { lazy } from 'react';

//供货商列表
const SupplierList = lazy(() => import('pages/supplierList'));
//供货商详情
const SupplierDetail = lazy(() => import('pages/supplierDetail'));
//供货商品牌类目新增
const SupplierBCAdd = lazy(() => import('pages/supplierBCAdd'));
//供货商详情
const SupplierBCDetail = lazy(() => import('pages/supplierBCDetail'));
// 保证金设置
const BondSetting = lazy(() => import('pages/bondSetting'));

export const router = {
    path: '/supplier',
    name: '供货商管理',
    icon: 'schedule',
    permission: 101,
    children: [
        {
            path: 'supplierList',
            name: '供货商列表',
            icon: 'profile',
            permission: 10101,
            component: SupplierList,
        },
        {
            path: 'supplierDetail',
            icon: '_space',
            hideInMenu: true,
            name: '供货商详情',
            permission: 10101,
            component: SupplierDetail,
        },
        {
            path: 'brandCategoryAdd',
            name: '供货商品牌类目新增',
            icon: 'profile',
            permission: 10102,
            component: SupplierBCAdd,
        },
        {
            path: 'brandCategoryDetail',
            icon: '_space',
            hideInMenu: true,
            name: '品牌类目新增详情',
            permission: 10102,
            component: SupplierBCDetail,
        },
        {
            path: 'bondSetting',
            icon: '_space',
            hideInMenu: true,
            name: '保证金设置',
            permission: 10102,
            component: BondSetting,
        },
    ],
};

export default router;
